var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timeslots booking-summary pt-2"},[_vm._l((_vm.selectedPets),function(pet){return _c('summary-item',{key:pet.id,attrs:{"pet":pet}})}),_c('total-amount')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }